<template>
  <el-dialog
    append-to-body
    :title="$t('financial.dialog.selectRechargeItem')"
    class="recharge-dialog"
    :visible.sync="show"
    :before-close="handleClose"
    width="673px"
  >
    <div class="recharge-dialog__box">
      <div
        class="recharge-dialog__item recharge-dialog__item_alipay"
        style="margin-right: 30px"
      >
        <header>
          <span>{{ $t('financial.payment.alipayPay') }}</span>
        </header>
        <section>
          <p class="recharge-dialog__item-name">{{ $t('financial.dialog.couponFor') }}</p>
          <p class="recharge-dialog__item-list">{{ $t('financial.dialog.listApplyVisa') }}</p>
          <p class="recharge-dialog__item-list">{{ $t('financial.dialog.listUseVisaTool') }}</p>
          <p class="recharge-dialog__item-list">{{ $t('financial.dialog.listUsaExpedited') }}</p>
          <button class="recharge-dialog__item-btn" @click="showNext">
            {{ $t('financial.payment.rechargeNow') }}
          </button>
        </section>
      </div>
      <div class="recharge-dialog__item recharge-dialog__item_bank">
        <header>{{ $t('financial.payment.bankTransfer') }}</header>
        <section>
          <img
            src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/bank.png"
          />
          <template v-if="channel === 'lyb'">
            <p class="recharge-dialog__item-list">{{ $t('financial.dialog.accountLabel') }}{{ $t('financial.dialog.lybAccount') }}</p>
            <p class="recharge-dialog__item-list">{{ $t('financial.dialog.lybAccountName') }}</p>
            <p class="recharge-dialog__item-list">{{ $t('financial.dialog.lybBankBranch') }}</p>
          </template>
          <template v-else>
            <p class="recharge-dialog__item-list">{{ $t('financial.dialog.accountLabel') }}{{ $t('financial.dialog.defaultAccount') }}</p>
            <p class="recharge-dialog__item-list">{{ $t('financial.payment.bankAccountName') }}</p>
            <p class="recharge-dialog__item-list">{{ $t('financial.payment.bankName') }}：{{ $t('financial.payment.bankBranch') }}</p>
          </template>
        </section>
      </div>
    </div>

    <el-alert :closable="false" style="margin-top: 16px">
      <ul style="margin: 0; padding: 0; list-style: none; line-height: 20px">
        <li>{{ $t('financial.dialog.notice1') }}</li>
        <li>{{ $t('financial.dialog.notice2') }}</li>
        <li>{{ $t('financial.dialog.notice3') }}</li>
      </ul>
    </el-alert>

    <ticket-recharge-dialog
      :show.sync="showTicketDialog"
    ></ticket-recharge-dialog>
  </el-dialog>
</template>

<script>
import TicketRechargeDialog from './TicketRechargeDialog'
import { getCookie } from '@/utils/util'

export default {
  name: 'couponRechargeDialog',
  components: {
    TicketRechargeDialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      showTicketDialog: false,
      channel: '',
    }
  },
  watch: {
    show(val, oldVal) {
      if (val && !oldVal) {
        const { userInfo } = getCookie()
        if (userInfo) {
          this.channel = userInfo.channel
        }
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit('update:show', false)
    },
    showNext() {
      this.showTicketDialog = true
    },
  },
}
</script>
<style lang="scss">
.recharge-dialog {
  &__box {
    display: flex;
    justify-content: center;
  }
  &__item {
    width: 50%;
    border: 1px solid #eee;
    border-radius: 6px;
    overflow: hidden;
    flex: 1;
    text-align: center;
    &_bank {
      header {
        background-color: $color-green-dark;
        span {
          padding-left: 36px;
          background: $color-green-dark
            url(https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/pre-save.png)
            no-repeat 0px center;
          background-size: 30px 30px;
        }
      }
    }
    &-name {
      color: $color-black-87 !important;
    }
    &-btn {
      margin-top: 24px;
      padding: 10px 40px;
      background: $color-blue-dark;
      border-radius: 4px;
      font-weight: 500;
      font-size: 14px;
      color: $color-white;
      line-height: 17px;
      border: none !important;
      cursor: pointer;
      &.pre-save {
        background: $color-green-dark;
      }
    }
    header {
      font-size: 16px;
      line-height: 26px;
      text-align: center;
      background: $color-blue;
      padding: 14px 60px 14px 24px;
      color: $color-white;
      span {
        padding: 5px 0;
        padding-left: 36px;
        font-weight: 500;
        background: $color-blue
          url(https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/point-recharge.png)
          no-repeat 0px center;
        background-size: 30px 30px;
      }
    }
    section {
      padding: 24px;
    }
    img {
      width: 57px;
      padding-bottom: 24px;
    }
    p {
      font-size: 14px;
      line-height: 24px;
      color: $color-green-dark;
      text-align: left;
      margin: 0;
      &.recharge-dialog__item-list {
        color: $color-black-54;
      }
      strong {
        font-weight: 500;
        color: $color-black-87;
      }
    }
  }
}
</style>
